import React from "react";
import {
  IconUserIdentity,
  IconUser,
  // IconAwards,
  IconVerification,
  IconHome,
  IconMoneyCheck,
  IconHandCoins,
  IconAudience,
  IconUserCard,
  IconBoxEmpty,
  IconDiscount,
  IconGear,
  IconCarouselDynamic,
  IconFAQ,
  IconUser2,
  IconStore,
  // IconPerformance,
  // IconChartPie,
  IconGift,
  // IconPerformance4,
  IconMonitorMedic,
  IconLeads2,
  IconPenDoc,
  IconHistory,
  IconTemplate,
  IconImageMap,
  // IconDelivery,
  IconTarget2,
  // IconAwards,
  // IconCalendar,
  // IconMoneyCoin,
} from "@aksara-ui/icons";
import { Box, theme } from "@aksara-ui/react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
} from "components/Accordion";
// import { ReactComponent as IconEthereum } from "assets/images/ethereum-icon.svg";
import { getRole, getTenant } from "hooks";

const userRole = getRole();
const userTenant = getTenant();

const isSuperAdmin = userRole === "superadmin";
const isAdmin = userRole === "admin";
const isPartner = userRole === "partner";
// const isUltraMilkTenant = userTenant === "Ultra Milk";
const isBatTenant = userTenant === "BAT";

const menuList = [
  (isSuperAdmin || isAdmin) && {
    Icon: IconHome,
    id: "home",
    name: "Home",
    path: "/",
    multiple: false,
  },
  // (isSuperAdmin || isAdmin) && {
  //   Icon: IconChartPie,
  //   id: "analytic",
  //   name: "Analytic",
  //   path: "/analytics",
  //   multiple: true,
  //   submenus: [
  //     // {
  //     //   Icon: IconMoneyCoin,
  //     //   id: "ultra-reward",
  //     //   name: "Ultra Rewards",
  //     //   path: "/analytics/ultra-reward",
  //     // },
  //     // {
  //     //   Icon: IconMoneyCoin,
  //     //   id: "raffle-activity",
  //     //   name: "Raffle Activity",
  //     //   path: "/analytics/raffle-activity",
  //     // },
  //     {
  //       Icon: IconPerformance,
  //       id: "membership-summary",
  //       name: "Membership Summary",
  //       path: "/analytics/membership-summary",
  //     },
  //     {
  //       Icon: IconPerformance4,
  //       id: "member-activity-summary",
  //       name: "Member Activity Summary",
  //       path: "/analytics/member-activity-summary",
  //     },
  //   ],
  // },
  (isSuperAdmin || isAdmin) && {
    Icon: IconUserIdentity,
    id: "membership",
    name: "Membership",
    path: "/members",
    multiple: true,
    submenus: [
      {
        Icon: IconAudience,
        id: "member",
        name: "Membership List",
        path: "/members/list",
      },
    ],
  },
  (isSuperAdmin || isAdmin) && {
    Icon: IconUserCard,
    id: "tier",
    name: "Tiering Management",
    path: "/tiers",
  },
 (isSuperAdmin || isAdmin) && {
    Icon: IconBoxEmpty,
    id: "products",
    name: "Products",
    path: "/products",
    multiple: true,
    submenus: [
      {
        Icon: IconMoneyCheck,
        id: "catalog",
        name: "Physical Goods",
        path: "/products/catalogs",
      },
      {
        Icon: IconDiscount,
        id: "voucher",
        name: "Digital Goods",
        path: "/products/vouchers",
      },
    ],
  },
  (isSuperAdmin || isAdmin || isPartner) && {
    Icon: IconGift,
    id: "raffle-ancol",
    name: "Raffle Grand Prize",
    path: "/raffle-ancol",
    multiple: false,
  },
  (isSuperAdmin || isAdmin || isPartner) && {
    Icon: IconGift,
    id: "raffle-ancol",
    name: "Raffle Reward Monthly",
    path: "/raffle-ancol-monthly",
    multiple: false,
  },
  // (isSuperAdmin || (isAdmin && isUltraMilkTenant)) && {
  //   Icon: IconDelivery,
  //   id: "reward-shipment",
  //   name: "Reward Shipment",
  //   path: "/reward-shipments",
  //   multiple: false,
  // },
  (isSuperAdmin || isAdmin) && {
    Icon: IconMonitorMedic,
    id: "activity",
    name: "Activity",
    path: "/activity",
    multiple: true,
    submenus: [
      // {
      //   Icon: IconPenDoc,
      //   id: "user-complaint",
      //   name: "User Complaint",
      //   path: "/activity/user-complaint",
      // },
      {
        Icon: IconPenDoc,
        id: "log-activity",
        name: "Log Activity",
        path: "/activity/log-activities",
      },
      (isSuperAdmin || isAdmin) && {
        Icon: IconLeads2,
        id: "point-activity",
        name: "Point Activity",
        path: "/activity/point-activities",
      },
      (isSuperAdmin || isAdmin) && {
        Icon: IconHistory,
        id: "ocr-activity",
        name: "OCR Activity",
        path: "/activity/ocr-activities",
      },
      (isSuperAdmin || isAdmin) && {
        Icon: IconGift,
        id: "redeem-activity",
        name: "Redeem Activity",
        path: "/activity/redeem-activities",
      },
    ],
  },
  // (isSuperAdmin || (isAdmin && isUltraMilkTenant)) && {
  //   Icon: IconDiscount,
  //   id: "raffles",
  //   name: "Raffle",
  //   path: "/raffles",
  //   multiple: true,
  //   submenus: [
  //     {
  //       Icon: IconHistory,
  //       id: "ocr-raffle-activity",
  //       name: "Raffle OCR Activity",
  //       path: "/raffles/ocr-activities",
  //     },
  //     {
  //       Icon: IconTarget2,
  //       id: "raffle",
  //       name: "Raffle",
  //       path: "/raffles/list",
  //     },
  //     {
  //       Icon: IconAwards,
  //       id: "raffle-winner",
  //       name: "Raffle Winner",
  //       path: "/raffles/winners",
  //     },
  //     {
  //       Icon: IconCalendar,
  //       id: "raffle-event",
  //       name: "Event",
  //       path: "/raffles/events",
  //     },
  //     {
  //       Icon: IconStore,
  //       id: "raffle-merchant",
  //       name: "Merchant",
  //       path: "/raffles/merchants",
  //     },
  //   ],
  // },
  (isSuperAdmin || isAdmin) && {
    Icon: IconHandCoins,
    id: "collect-point",
    name: "Collection Point",
    path: "/collect-points",
    multiple: false,
  },
  (isSuperAdmin || isAdmin) && {
    Icon: IconVerification,
    id: "warranty",
    name: "Warranty Management",
    path: "/warranties",
    multiple: false,
  },
  (isSuperAdmin || isAdmin) && {
    Icon: IconTarget2,
    id: "quests",
    name: "Quest Management",
    path: "/quests",
    multiple: false,
  },
  isSuperAdmin && {
    Icon: IconUser2,
    id: "account",
    name: "Account",
    path: "/account",
    multiple: true,
    submenus: [
      {
        Icon: IconUser,
        id: "user",
        name: "User Management",
        path: "/account/users",
        multiple: false,
      },
      {
        Icon: IconStore,
        id: "tenant",
        name: "Tenant Management",
        path: "/account/tenants",
        multiple: false,
      },
    ],
  },
  (isSuperAdmin || isAdmin) && {
    Icon: IconCarouselDynamic,
    id: "config",
    name: "Configuration",
    path: "/config",
    multiple: true,
    submenus: [
      (isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant) && {
        Icon: IconTemplate,
        id: "banner",
        name: "Banner Management",
        path: "/config/banners",
        multiple: false,
      },
      (isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant) && {
        Icon: IconImageMap,
        id: "media",
        name: "Media Management",
        path: "/config/media",
        multiple: false,
      },
      {
        Icon: IconGear,
        id: "general-setting",
        name: "General Setting",
        path: "/config/general-settings",
        multiple: false,
      },
      (isSuperAdmin || (isAdmin && isBatTenant) || isBatTenant) && {
        Icon: IconFAQ,
        id: "help-center",
        name: "Help Center",
        path: "/config/help-center",
        multiple: false,
      },
    ],
  },
].filter(Boolean);

const MenuWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
`;

const MenuItem = styled(Box)<{
  $isActive?: boolean;
  $sidebarExpand?: boolean;
  $isLink?: boolean;
}>`
  all: unset;
  display: flex;
  justify-content: ${(props) => (props.$sidebarExpand ? "left" : "center")};
  align-items: center;
  gap: 8px;
  padding: 12px;
  font-size: 14px;
  border-radius: 8px !important;
  cursor: pointer;
  transition: opacity 0.3s 0.2s, height 0.5s;
  color: ${(props) =>
    props.$isActive && props.$isLink
      ? theme.colors.blue06
      : !props.$isActive && props.$isLink
      ? "#313F4E"
      : props.$isActive && !props.$isLink
      ? theme.colors.blue06
      : "#313F4E"};
  background-color: ${(props) =>
    props.$isActive && props.$isLink
      ? "#EBF5FF"
      : !props.$isActive && props.$isLink
      ? theme.colors.white
      : props.$isActive && !props.$isLink
      ? theme.colors.white
      : theme.colors.white};

  &:hover {
    font-size: 14px;
  }

  svg {
    path {
      fill: ${(props) =>
        props.$isActive && props.$isLink
          ? theme.colors.blue06
          : !props.$isActive && props.$isLink
          ? "#313F4E"
          : props.$isActive && !props.$isLink
          ? theme.colors.blue06
          : "#313F4E"};
    }
  }

  &:hover {
    background: ${(props) =>
      props.$isLink ? (props.$isActive ? "#E0EDFA" : "#E0EDFA") : ""};
    color: ${(props) =>
      props.$isLink
        ? props.$isActive
          ? theme.colors.blue06
          : theme.colors.blue06
        : ""};
    svg {
      path {
        fill: ${(props) =>
          props.$isLink
            ? props.$isActive
              ? theme.colors.blue06
              : theme.colors.blue06
            : ""};
      }
    }
  }
`;

type MenusProps = {
  sidebarExpand: boolean;
};

const Menus: React.FC<MenusProps> = ({ sidebarExpand }) => {
  const currLoc = window.location.pathname;
  return (
    <MenuWrapper mt={32}>
      {menuList.map((menu, index) => {
        return (
          <Box key={index}>
            {menu ? (
              <Box marginBottom={12}>
                {!menu.multiple ? (
                  <NavLink to={menu.path}>
                    <MenuItem
                      $isActive={
                        currLoc === menu.path ||
                        currLoc.substring(0, menu.path.length + 1) ===
                          menu.path + "/"
                      }
                      $sidebarExpand={sidebarExpand}
                      $isLink={true}
                    >
                      <menu.Icon />

                      {sidebarExpand ? (
                        <>
                          <Box style={{ marginRight: 2 }} />
                          {menu.name}
                        </>
                      ) : (
                        ""
                      )}
                    </MenuItem>
                  </NavLink>
                ) : (
                  <Accordion
                    defaultValue={[
                      currLoc === menu.path ||
                      currLoc.substring(0, menu.path.length + 1) ===
                        menu.path + "/"
                        ? currLoc.substring(0, menu.path.length + 1)
                        : "",
                    ]}
                    type="multiple"
                  >
                    <AccordionItem
                      value={currLoc.substring(0, menu.path.length + 1)}
                    >
                      <AccordionHeader
                        isActive={
                          currLoc === menu.path ||
                          currLoc.substring(0, menu.path.length + 1) ===
                            menu.path + "/"
                        }
                        isExpand={sidebarExpand}
                      >
                        <MenuItem
                          $isActive={
                            currLoc === menu.path ||
                            currLoc.substring(0, menu.path.length + 1) ===
                              menu.path + "/"
                          }
                          $sidebarExpand={sidebarExpand}
                          $isLink={false}
                        >
                          <menu.Icon />{" "}
                          {sidebarExpand ? (
                            <>
                              <Box style={{ marginRight: 2 }} />
                              {menu.name}
                            </>
                          ) : (
                            ""
                          )}
                        </MenuItem>
                      </AccordionHeader>
                      {menu.submenus?.map((submenu, index) => {
                        return (
                          <AccordionContent key={index}>
                            {submenu ? (
                              <Box
                                py={"xs"}
                                paddingBottom={0}
                                paddingLeft={sidebarExpand ? 25 : 0}
                              >
                                <NavLink to={submenu.path}>
                                  <MenuItem
                                    $isActive={
                                      currLoc === submenu.path ||
                                      currLoc.substring(
                                        0,
                                        submenu.path.length + 1
                                      ) ===
                                        submenu.path + "/"
                                    }
                                    $sidebarExpand={sidebarExpand}
                                    $isLink={true}
                                  >
                                    <submenu.Icon />
                                    {sidebarExpand ? (
                                      <>
                                        <Box style={{ marginRight: 2 }} />
                                        {submenu.name}
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </MenuItem>
                                </NavLink>
                              </Box>
                            ) : (
                              ""
                            )}
                          </AccordionContent>
                        );
                      })}
                    </AccordionItem>
                  </Accordion>
                )}
              </Box>
            ) : (
              <></>
            )}
          </Box>
        );
      })}
    </MenuWrapper>
  );
};

export default Menus;
